import {AcceptOrRefuseSectionProps} from "./types";
import {useIntl} from "react-intl";
import Button from "@ui-components/Button";
import {useState} from "react";

export const AcceptOrRefuseSection = ({
  onAccept,
  onRefuse,
  text
}: AcceptOrRefuseSectionProps) => {
  const intl = useIntl();
  const [loadingAccept, setLoadingAccept] = useState(false);
  const [loadingRefuse, setLoadingRefuse] = useState(false);
  return <div className={"my-10 py-5"} id={"accept-refuse-div"}>
    <div className={"border border-gray-600 bg-white shadow overflow-hidden sm:rounded-lg"} >
      <div className="px-4 py-5">
      <span className={"text-lg"}>
        {text}
      </span>
        <div className={"flex flex-row justify-center gap-2 mt-8"}>
          <Button
            styleType={"green"}
            onClick={async () => {
              setLoadingAccept(true);
              await onAccept();
              setLoadingAccept(false);
            }}
            submitting={loadingAccept}
            disabled={loadingRefuse}
          >
            {intl.formatMessage({
              id: "accept",
              defaultMessage: "Accetta",
            })}
          </Button>
          <Button
            styleType={"red"}
            onClick={async () => {
              setLoadingRefuse(true);
              await onRefuse();
              setLoadingRefuse(false);
            }}
            submitting={loadingRefuse}
            disabled={loadingAccept}
          >
            {intl.formatMessage({
              id: "refuse",
              defaultMessage: "Rifiuta",
            })}
          </Button>
        </div>
      </div>
    </div>
  </div>
}